import { RgbStringColorPicker } from 'react-colorful';
import { DicomColor } from '~/domain/dicom/dicomColor';
import { extractRGBNumbers } from '~/domain/dicom/utils';
import { dicomColorToRgbString } from '~/utils/color';

/**
 * Saturation/value square and hue slider for an 8-bit DICOM colour.
 * Controlled: shows `color` and reports every change of the pointer or
 * the arrow keys through `onChange`, per move — a caller that must not
 * act per move holds the value as a draft of its own. A press picks from
 * the colour shown after whatever held the focus has given it up, so a
 * field that settles its value on losing focus has settled it by then.
 */
export default function DicomColorPicker({
    color,
    onChange,
}: {
    color: DicomColor;
    onChange: (color: DicomColor) => void;
}) {
    return (
        <RgbStringColorPicker
            color={dicomColorToRgbString(color)}
            onChange={(rgbString) => {
                const [R, G, B] = extractRGBNumbers(rgbString);
                onChange({ R, G, B });
            }}
            // The picker takes the focus and reads the colour to pick from
            // in one step of a press, ahead of anything the focus' holder
            // does on losing it. The holder gives it up a step earlier.
            onPointerDownCapture={({ currentTarget }) => {
                const focused = document.activeElement;
                if (
                    focused instanceof HTMLElement &&
                    !currentTarget.contains(focused)
                ) {
                    focused.blur();
                }
            }}
        />
    );
}
